import { S3Video, S3VideoProps } from '../s3-video';
import { getUserPath } from './get-path';

export type S3UserVideoProps = {
  userId: string;
  s3Key?: string;
} & Omit<S3VideoProps, 'path'>;

export const S3UserVideo = function S3UserImg({
  ref,
  userId,
  s3Key,
  ...rest
}: S3UserVideoProps & {
  ref?: React.Ref<HTMLVideoElement>;
}) {
  return (
    <S3Video
      ref={ref}
      path={s3Key ? getUserPath(userId, s3Key) : undefined}
      {...rest}
    />
  );
};
